import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Phone, Mail, MapPin } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your interest! We will contact you soon.');
    setFormData({ name: '', email: '', phone: '', course: '', message: '' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Page Header */}
      <section className="bg-gradient-to-b from-red-50 to-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Get In Touch</h1>
              <p className="text-xl text-gray-600">
                Ready to start your journey? Contact us today and take the first step towards your success
              </p>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1680344427682-ccb4e98a4d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxyZXNlcnZlJTIwYmFuayUyMGluZGlhJTIwYnVpbGRpbmclMjBtdW1iYWl8ZW58MHx8fHwxNzcyNjk0NTkzfDA&ixlib=rb-4.1.0&q=85" 
                alt="Gateway of India Mumbai" 
                className="rounded-2xl shadow-xl w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Contact Form */}
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Send us a message</CardTitle>
                <CardDescription>Fill out the form and we'll get back to you soon</CardDescription>
              </CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      placeholder="Your name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      placeholder="your.email@example.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      placeholder="Your phone number"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Interested Course</label>
                    <select
                      name="course"
                      value={formData.course}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    >
                      <option value="">Select a course</option>
                      <option value="SSC CGL">SSC CGL</option>
                      <option value="SSC CHSL">SSC CHSL</option>
                      <option value="SSC MTS">SSC MTS</option>
                      <option value="SSC CPO">SSC CPO</option>
                      <option value="IBPS PO">IBPS PO</option>
                      <option value="SBI PO">SBI PO</option>
                      <option value="RRB PO">RRB PO</option>
                      <option value="IBPS Clerk">IBPS Clerk</option>
                      <option value="SBI Clerk">SBI Clerk</option>
                      <option value="RRB Clerk">RRB Clerk</option>
                      <option value="RBI Grade B">RBI Grade B</option>
                      <option value="RBI Assistant">RBI Assistant</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="4"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      placeholder="Any questions or special requirements?"
                    ></textarea>
                  </div>
                  <Button type="submit" className="w-full bg-red-500 hover:bg-red-600 text-white py-6 text-lg">
                    Submit Inquiry
                  </Button>
                </form>
              </CardContent>
            </Card>

            {/* Contact Information */}
            <div className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle className="text-2xl">Contact Information</CardTitle>
                  <CardDescription>Reach out to us through any of these channels</CardDescription>
                </CardHeader>
                <CardContent className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="bg-red-100 p-3 rounded-lg">
                      <Phone className="text-red-500" size={24} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Phone</h4>
                      <p className="text-gray-600">+91 8750410365</p>
                      <p className="text-gray-600">+91 8700766594</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-red-100 p-3 rounded-lg">
                      <Mail className="text-red-500" size={24} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
                      <p className="text-gray-600">info@vidya365.com</p>
                      <p className="text-gray-600">admissions@vidya365.com</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-red-100 p-3 rounded-lg">
                      <MapPin className="text-red-500" size={24} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Address</h4>
                      <p className="text-gray-600">
                        Vidya365 Coaching Center<br />
                        Unit 8, Apsara Arcade<br />
                        Near Karol Bagh Metro Gate 7<br />
                        Pusa Road, Karol Bagh<br />
                        New Delhi - 110005
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-red-500 text-white">
                <CardContent className="pt-6">
                  <h3 className="text-2xl font-bold mb-2">Office Hours</h3>
                  <p className="mb-4">We're here to help you succeed</p>
                  <div className="space-y-2">
                    <p><strong>Monday - Saturday:</strong> 8:00 AM - 8:00 PM</p>
                    <p><strong>Sunday:</strong> 9:00 AM - 5:00 PM</p>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-red-50 to-white border-2 border-red-100">
                <CardContent className="pt-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Visit Our Center</h3>
                  <p className="text-gray-600 mb-4">
                    Come visit us for a campus tour and meet our expert faculty. We're open for walk-in consultations 
                    during office hours.
                  </p>
                  <p className="text-sm text-gray-500 mb-4">
                    Please call ahead to schedule a personalized counseling session with our admission team.
                  </p>
                  
                  {/* Google Maps Embed */}
                  <div className="mt-6 rounded-lg overflow-hidden border-2 border-gray-200">
                    <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.491206146657!2d77.19421679999999!3d28.645007399999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd81d2c99379%3A0xc5e1f19124cadee2!2sVIDYA365%20Coaching%20%7C%20SSC%20CGL%2C%20CHSL%2C%20MTS%2C%20GD%20%7C%20RBI%20Grade%20B%2C%20NABARD%2C%20SEBI%2C%20SBI%20PO%2C%20IBPS!5e0!3m2!1sen!2sin!4v1775306770634!5m2!1sen!2sin" 
                      width="100%" 
                      height="300" 
                      style={{border: 0}} 
                      allowFullScreen="" 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Vidya365 Location Map"
                    ></iframe>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
